// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStkstatalink } from "../../../icons/full/build/icon-stkstatalink.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StkstatalinkIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStkstatalink.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StkstatalinkIcon.displayName = 'StkstatalinkIcon';
}

export default StkstatalinkIcon;